export const environment = {
  production: true,
  baseHref: '',
  baseUrl: 'cheetah/api/',
  baseChirpUrl: 'chirp/api/',
  baseGoatUrl: 'goat/api/',
  releaseName: 'rdowling-icario-attribute-interval-cap-delete-bug-717',
  buildNumber: '6ee890047b-',
};
